import { NetworkManager } from '../../services';
import { useQuery } from '../../services/NetworkManager';
import { AgreementStatus } from '../../components/organisms/AgreementGate/useAgreementGate';

export type EntityType = 'INDIVIDUAL' | 'COMPANY' | 'LLP' | 'HUF' | 'PROPRIETORSHIP';
export type RelationType = 'SON_OF' | 'DAUGHTER_OF' | 'WIFE_OF';
export type RegistrationType = 'CIN' | 'LLPIN' | 'GSTIN' | 'OTHER';

/** The agreement's blanks. Name and PAN of an individual come from the verified KYC. */
export interface AgreementDetails {
  entityType: EntityType;
  // individual
  age?: number | null;
  relationType?: RelationType | null;
  relationName?: string | null;
  // company / LLP / HUF / sole proprietorship
  entityName?: string | null;
  registrationType?: RegistrationType | null;
  registrationNumber?: string | null;
  entityPan?: string | null;
  // optional for an individual, required otherwise
  registeredOffice?: string | null;
  // notices to the partner
  noticeAddress?: string | null;
  noticeAttention?: string | null;
  noticeEmail?: string | null;
}

export interface AgreementOverview {
  status: AgreementStatus;
  esignEnabled: boolean;
  validUntil?: string;
  renewBy?: string;
  prefill: {
    name?: string;
    pan?: string;
    age?: number;
    email?: string;
    phone?: string;
    address?: string;
    gstin?: string;
    cin?: string;
  };
  latest?: {
    publicId: string;
    status: 'SIGN_PENDING' | 'SIGNED' | 'FAILED' | 'CANCELLED';
    details?: AgreementDetails;
    signedAt?: string;
    validUntil?: string;
    failureReason?: string;
  };
}

export const AGREEMENT_QUERY_KEY = 'agreement';

export default function useAgreement() {
  const { data, isLoading, refetch } = useQuery(AGREEMENT_QUERY_KEY, () =>
    NetworkManager.Call({ method: 'get', path: NetworkManager.PATH.getAgreement }),
  );
  return { overview: data?.data as AgreementOverview | undefined, isLoading, refetch };
}

export const startAgreementEsign = (details: AgreementDetails) =>
  NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.startAgreementEsign,
    data: details,
  });

export const syncAgreementEsign = (esignId: string) =>
  NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.syncAgreementEsign.replace('{{esignId}}', esignId),
  });

export const getSignedAgreementUrl = (esignId: string) =>
  NetworkManager.Call({
    method: 'get',
    path: NetworkManager.PATH.downloadSignedAgreement.replace('{{esignId}}', esignId),
  });
